import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/src/components/ui/button.tsx";
import { handleAnalyticsClick } from "@/src/utils/analytics";

const StoreCarousel = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const storeItems = [
        {
            id: 1,
            title: "Personal System 個人システム \"Liminal City '87\"",
            description: "Professionally dubbed cassette/CD",
            image: "https://142810239.cdn6.editmysite.com/uploads/1/4/2/8/142810239/AGUAFBBMVDLEU433JJKLUJTT.jpeg?width=320&dpr=1",
            link: "https://dream-chimney-store.square.site/product/personal-system-liminal-city-87-cassette/I4JSNQ7M24Q6ZVXUSPRV7YN3?cs=true&cst=custom"
        },
        {
            id: 2,
            title: "Sorcerer \"Sunlight Hits\" CD/Cassette",
            description: "CD digipack lite with clear tray",
            image: "https://142810239.cdn6.editmysite.com/uploads/1/4/2/8/142810239/FUGQV3NSB6ZEL6JB7E4OJ3PV.jpeg?width=2400&optimize=medium",
            link: "https://dream-chimney-store.square.site/product/sorcerer-sunlight-hits-cd/ZMW57LIONOOIFNLFCFGCU5RO?cs=true&cst=custom"
        },
        {
            id: 3,
            title: "Ray Cheser \"Soft Motion\"",
            description: "Official re-release of the 1987 new age synth album.",
            image: "https://142810239.cdn6.editmysite.com/uploads/1/4/2/8/142810239/WMEZNAC6KPDHODCEB5CBPAHD.jpeg?width=320&dpr=1",
            link: "https://dream-chimney-store.square.site/product/ray-cheser-soft-motion-cassette-/JGIJFGVZ7YM5VCHPB4WRATMW?cs=true&cst=custom"
        },

        {
            id: 4,
            title: "DC Tote Bag",
            description: "Shop in style with the new DC Record Tote.",
            image: "https://f4.bcbits.com/img/0014456333_36.jpg",
            link: "https://dreamchimney.bandcamp.com/merch/dc-record-tote"
        },
        {
            id: 5,
            title: "Dream Chimney Slipmat",
            description: "Limited edition felt slipmat featuring the Dream Chimney logo.",
            image: "https://www.dreamchimney.com/mainpage/merch/DC-Slipmat-2.jpg",
            link: "/store/slipmat"
        },
        {
            id: 6,
            title: "DC Crystal Tie-Dyed T-Shirt",
            description: "Available in M, L and XL while supplies last",
            image: "https://f4.bcbits.com/img/0036882450_10.jpg",
            link: "/store/tshirt"
        },

    ];

    const totalSlides = Math.ceil(storeItems.length / 2);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    };

    const handleStoreItemClick = (event, item) => {
        const eventParams = {
            eventCategory: 'Store',
            eventAction: 'Click',
            eventLabel: `${item.title}`,
            itemId: item.id,
            itemType: 'store_product'
        };

        handleAnalyticsClick('home_store_item', eventParams, event);
    };

    return (

        <div className="relative">
            <div className="overflow-hidden">
                <div
                    className="flex transition-transform duration-300 ease-in-out"
                    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                    {storeItems.map((item) => (
                        <div key={item.id} className="w-1/2 flex-shrink-0 px-2">
                            <a href={item.link} target="_blank" className="block group no-underline" onClick={(e) => handleStoreItemClick(e, item)}>
                                <div className="relative">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full aspect-square object-cover rounded-lg group-hover:opacity-90 transition-opacity"
                                    />
                                </div>
                                <div className="mt-3">
                                    <h3 className="font-bold text-sm mb-1">{item.title}</h3>
                                    <p className="text-xs text-gray-400 mb-2">{item.description}</p>
                                    <Button
                                        size="sm"
                                        className="w-full bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-xs"
                                    >
                                        Shop Now
                                    </Button>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </div>

            <Button
                variant="ghost"
                size="icon"
                className="absolute left-0 top-1/2 -translate-y-1/2 z-20 bg-black/50 hover:bg-black/70 text-white"
                onClick={prevSlide}
            >
                <ChevronLeft className="h-6 w-6" />
            </Button>

            <Button
                variant="ghost"
                size="icon"
                className="absolute right-0 top-1/2 -translate-y-1/2 z-20 bg-black/50 hover:bg-black/70 text-white"
                onClick={nextSlide}
            >
                <ChevronRight className="h-6 w-6" />
            </Button>
        </div>

    );
};

export default StoreCarousel; 